<template>
  <dr-wrapper v-if="isInEditorMode" v-bind="$props" v-on="wrapOn">
    <v-autocomplete
      :label="evaluateExpression(model.Caption)"
      :class="evaluateClasses(classes)"
      :regular="isRegular"
      :solo="isSolo"
      :outlined="isOutlined"
      :filled="isFilled"
    />
  </dr-wrapper>

  <v-autocomplete
    v-else-if="isVisible"
    ref="drAutocompleteElemRef"
    :readonly="isReadonly"
    :disabled="isDisabled"
    :clearable="isClearable"
    :label="label"
    :class="evaluateClasses(classes)"
    :items="items"
    :rules="_isRequiredField"
    :item-text="this.dataSourceObject.name"
    :item-value="this.dataSourceObject.code"
    :search-input.sync="search"
    v-model="value"
    :regular="isRegular"
    :solo="isSolo"
    :outlined="isOutlined"
    :filled="isFilled"
    @change="invokeActionOnClick(model.GenerationOnChange, { value: $event })"
    :multiple="model.Multiple"
  >
    <template v-if="label || model.Required" #label>
      <span v-if="label">{{ label }}</span>
      <span v-if="model.Required" class="dr-autocomplete-required-hint">*</span>
    </template>
  </v-autocomplete>
</template>

<script>
import mixin from '../../mixins/base-mixin'
import inputMixin from '../../mixins/input-mixin'
import actionMixin from '../../mixins/actions-mixin'
import inputWidgetsValidateMixin from '../../mixins/input-widgets-validate-mixin'
import inputWidgetsWrapperMixin from '../../mixins/input-widgets-wrapper-mixin'
import BusinessObject from './businessObject'
import DataSource from './dataSource'

export default {
  mixins: [mixin, inputMixin, actionMixin, inputWidgetsWrapperMixin, inputWidgetsValidateMixin],
  data() {
    return {
      dataSourceObject: null
    }
  },
  async created() {
    if (this.isInEditorMode) {
      return
    }
    let name = this.model.Name || this.model.DataSource.Name
    let code = this.model.Code || this.model.DataSource.Code
    let dataSourceValue = this.model.DataSource.Value

    if (this.isBusinessObject) {
      this.dataSourceObject = new BusinessObject(this, name, code, dataSourceValue)
    } else {
      let dataSourceField = this.model.DataSource.DataSourceField
      this.dataSourceObject = new DataSource(this, name, code, dataSourceValue, dataSourceField)
    }

    await this.dataSourceObject.initialize()
    // Запросить и обновить данные нашего текущего датасоурса на актуальные
    await this.dataSourceObject.refresh()

    this.dataSourceObject.onAutocompleteCreated(this.value)
  },
  computed: {
    label() {
      return this.evaluateExpression(this.model.Caption)
    },
    isClearable() {
      if (this.isReadonly) {
        return false
      }
      return this.model.Clearable
    },
    _isRequiredField() {
      if (!this.model.Required) {
        return []
      }
      return [val => (val || '').length > 0 || `${this.model.Caption} - ${this.$t('vuetifyWidgets.dr-text-field.required')}`]
    },

    isBusinessObject() {
      return this.model.DataSource.Type === 'businessobject'
    },
    search: {
      get() {
        return this.dataSourceObject.searchValue
      },
      set(v) {
        if (this.dataSourceObject.searchValue === v) {
          return
        }
        this.dataSourceObject.onAutocompleteInput(v)
      }
    },

    items() {
      return this.dataSourceObject.getItems()
    },

    value: {
      get() {
        return this.getDataSourceField(this.model.Value)
      },
      set(v) {
        this.setDataSourceField(this.model.Value, v)
      }
    }
  }
}
</script>

<style>
.dr-autocomplete-required-hint {
  font-size: 25px;
  color: red;
}
</style>
